<template>
  <!-- 手术统计 -->
  <div>
    <div class="header">
      <span>手术统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="circle-warp" v-if="showOrg">
      <div class="exCircle" @click="showChildOperationList(item.children)" v-for="item in OrgOperationList"
           :key="item.oid" :style="{backgroundColor: item.total === 0 ? '#D9D9D9'  :'#7ecf51'}">
        <div class="inCircle">
          {{item.total}}
        </div>
        <div class="circle-name">{{item.name}}</div>
      </div>
    </div>
    <div v-if="showChild" class="circle-warp">
      <div class="exCircle" style="background-color: #1890ff;" @click="back('org')">
        <div class="inCircle">
          <i class="el-icon-back" style="font-size: 80px; text-align: center; line-height: 110px; color: #1890ff"></i>
        </div>
        <div class="circle-name">返回上一级</div>
      </div>
      <div class="exCircle" v-for="(item, i) in childOperationList" @click="userCountOrg(item.id)"
           :key="i" :style="{backgroundColor: item.total === 0 ? '#D9D9D9'  :'#7ecf51'}">
        <div class="inCircle">
          {{item.total}}
        </div>
        <div class="circle-name">{{item.name}}</div>
      </div>
    </div>
    <div v-loading="operationLoading" v-if="showUser && userOperationList.length > 0" class="circle-warp">
      <div class="exCircle" style="background-color: #1890ff;" @click="back('child')">
        <div class="inCircle">
          <i class="el-icon-back" style="font-size: 80px; text-align: center; line-height: 110px; color: #1890ff"></i>
        </div>
        <div class="circle-name">返回上一级</div>
      </div>
      <div style="position: relative" v-for="(item, i) in userOperationList" :key="i">
        <eber-operation-pie :operation-data="item"></eber-operation-pie>
        <div class="user-name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import OperationCountService from '@/request/count/operation'
import EberOperationPie from "./eber-operation-pie";
export default {
  name: 'CountOperation',
  components: {EberOperationPie},
  props: {
    orgs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data () {
    return {
      start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
      end: moment().endOf('day').valueOf(), // 结束时间
      dateRadio: '日',
      dateType: 'date',
      OrgOperationList: [],
      childOperationList: [],
      userOperationList: [],
      showChild: false,
      showOrg: true,
      showUser: false,
      operationLoading: true
    }
  },
  computed: {},
  created() {
    this.operationCountOrg();
  },
  watch:{
    orgs(){
      this.operationCountOrg();
    },
  },
  methods: {
    operationCountOrg() {
      if (this.orgs.length <= 0) {
        return
      }
      const orgIds = [];
      _.forEach(this.orgs, val => {
        if (val.typeId === 2 || val.typeId === 3) {
          orgIds.push(val.id);
        }
      });
      let type = 'day';
      if (this.dateType !== 'date') {
        type = this.dateType
      }
      OperationCountService.countOrg({
        start: moment(this.start).startOf(type).valueOf(),
        end: moment(this.end).endOf(type).valueOf(),
        oids: _.join(orgIds),
      }).then( res => {
        const opreationsList = res.result || [];
        const dataList = this.toTree(_.orderBy(opreationsList, ['total'], ['desc']));
        this.OrgOperationList = dataList.result;
        this.showOrg = true;
        this.showChild = false;
        this.showUser = false;
      }).finally(() => {
        this.operationLoading = false
      })
    },
    userCountOrg(oid) {
      if (oid) {
        this.showUser =true;
        this.showChild = false;
        this.showOrg = false;
        this.operationLoading = true;
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        OperationCountService.countUser({
          start: moment(this.start).startOf(type).valueOf(),
          end: moment(this.end).endOf(type).valueOf(),
          oids: oid
        }).then( res => {
          this.userOperationList = res.result;
          this.operationLoading = false;
        }).finally(() => {
          this.operationLoading = false
        })
      }
    },
    showChildOperationList(child) {
      if (child && child.length > 0) {
        this.showChild = true;
        this.showOrg = false;
        this.showUser = false;
        this.childOperationList = _.clone(child);
      } else {
        this.$message({
          message: '没有设置科室!',
          type: 'warning'
        });
      }
    },
    /**
     * 返回上一层
     * @param param  返回到哪一层
     */
    back(param) {
      if (param === 'org') {
        this.showChild = false;
        this.showOrg = true;
        this.showUser = false;
        return
      }
      if (param === 'child') {
        this.showUser = false;
        this.showChild = true;
        this.showOrg = false;
      }
    },
    dateRadioChange(event) {
      switch (event) {
        case '年':
          this.dateType = 'year';
          this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
          this.end =  moment().endOf('year').valueOf(); // 结束时间
          break;
        case '月':
          this.dateType = 'month';
          this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
          this.end =  moment().endOf('month').valueOf(); // 结束时间
          break;
        default:
          this.dateType = 'date';
          this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
          this.end =  moment().endOf('day').valueOf(); // 结束时间
      }
      this.dateChange();
    },
    dateChange() {
      if (!this.start || !this.end) {
        this.$message({
          message: '开始时间或结束时间不能为空',
          type: 'warning'
        });
        return
      }
      if (this.start > this.end) {
        this.$message({
          message: '开始时间不能大于结束时间',
          type: 'warning'
        });
      }
      this.operationCountOrg();
    },
    toTree(followupList){
      let result = [], temp = {}, i = 0, j = 0, max = 0, len = followupList.length;
      for(; i < len; i++){
        temp[followupList[i]['id']] = followupList[i]; // 以id作为索引存储元素，可以无需遍历直接定位元素
        if (max < followupList[i].total) {
          max = followupList[i].total
        }
      }
      for(; j < len; j++){
        var currentElement = followupList[j];
        var tempCurrentElementParent = temp[currentElement['pid']]; // 临时变量里面的当前元素的父元素
        if (tempCurrentElementParent) { // 如果存在父元素
          if (!tempCurrentElementParent['children']) { // 如果父元素没有chindren键
            tempCurrentElementParent['children'] = [] // 设上父元素的children键
          }
          tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
        } else { // 不存在父元素，意味着当前元素是一级元素
          result.push(currentElement);
        }
      }
      return {result,  max};
    },
  },
  filters: {}
}
</script>

<style scoped>
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
  .circle-warp {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 150px;
  }
  .exCircle {
    margin: 30px 26px;
    width: 120px;
    height: 120px;
    border-radius: 120px;
    position: relative;
  }
  .inCircle{
    margin-top: 5px;
    margin-left: 5px;
    position: absolute;
    width: 110px;
    height: 110px;
    font-size: 21px;
    color: #666666;
    border-radius: 110px;
    text-align: center;
    line-height: 110px;
    background-color: #FFFFFF;
  }
  .circle-name {
    bottom: -50px;
    left: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
  }
  .user-name {
    text-align: center;
    position: absolute;
    bottom: -10px;
    left: 26px;
    width: 120px;
    max-height: 40px;
  }
</style>
